import { IonButton, IonContent, IonInput, IonItem, IonList, IonPage, IonSpinner } from '@ionic/react';
import { sendSignInLinkToEmail } from 'firebase/auth';
import React, { useState } from 'react';
import GoogleLoginButton from '../../components/GoogleLoginButton';
import LogoutButton from '../../components/LogoutButton';
import PageHeader from '../../components/PageHeader';
import { useUser } from '../../contexts/UserContext';
import { auth } from '../../firebaseConfig';

const LoginPage: React.FC = () => {
  const { user, isUserLoading } = useUser();
  const [email, setEmail] = useState<string>('');

  const sendSignInLink = async () => {
    const { protocol, hostname, port } = window.location;
    const redirectUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}/login`;
    const actionCodeSettings = {
      url: redirectUrl, // Update this to your app's URL
      handleCodeInApp: true,
    };

    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);
      alert('Sign-in link sent!');
    } catch (error) {
      console.error('Error sending email link', error);
    }
  };

  if (isUserLoading) {
    return (
      <IonPage>
        <PageHeader title="Loading..." />
        <IonContent className="ion-padding">
          <IonSpinner />
        </IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage>
      <PageHeader title={user ? `Welcome, ${user.displayName}` : 'Login'} />
      <IonContent className="ion-padding">
        {user ? (
          <LogoutButton />
        ) : (
          <IonList>
            <IonItem>
              <IonInput value={email} placeholder="Enter your email" onIonChange={(e) => setEmail(e.detail.value!)} />
              <IonButton onClick={sendSignInLink}>Send Sign-In Link</IonButton>
            </IonItem>
            <IonItem>
              <GoogleLoginButton />
            </IonItem>
          </IonList>
        )}
      </IonContent>
    </IonPage>
  );
};

export default LoginPage;
